/*
* 同意処理API - DB保存の共通処理
*/
export default class ConsentApi {
  // 投資家登録同意を保存
  static async saveInvestorConsent(linkId, endpoint) {
    if (!linkId || !endpoint) {
      const error = new Error('linkId and endpoint are required');
      this.dispatchError('validation-error', error);
      return Promise.reject(error);
    }

    try {
      const formData = new FormData();
      formData.append('link_id', linkId);
      const response = await this.makeRequest(endpoint, formData);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response;
    } catch (error) {
      this.dispatchError('save-investor-consent', error);
      throw error;
    }
  }

  // プライバシー同意を保存
  static async savePrivacyConsent() {
    try {
      const response = await this.makeRequest('/privacy_consents');

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response;
    } catch (error) {
      this.dispatchError('save-privacy-consent', error);
      throw error;
    }
  }

  // 共通のリクエスト処理
  static async makeRequest(endpoint, formData = new FormData()) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (!csrfToken) {
      const error = new Error('CSRF token not found');
      this.dispatchError('csrf-token-missing', error);
      return Promise.reject(error);
    }

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken
        },
        body: formData
      });

      return response;
    } catch (error) {
      console.error('Network error during consent save:', error);
      this.dispatchError('network-error', error);
      throw error;
    }
  }

  // エラーイベントの発火
  static dispatchError(errorType, error) {
    document.dispatchEvent(new CustomEvent('consent:error', {
      detail: {
        type: errorType,
        error: error,
        message: error.message
      }
    }));
  }
}
